<template>
  <div class="header-wrapper row m-0">
    <SearchBar />
    <Logo />
    <div class="left-header col horizontal-wrapper pl-0">
      <ul class="horizontal-menu">
        <MobileMenu />
        <!--<BonusUI />
        <LevelMenu />-->
      </ul>
      <div
        class="col-xl-12 p-0 left-btn header-extra-buttons"
        v-if="CompanyLinks.length > 0"
      >
        <template v-for="(CompanyLink, CompanyLinkIndex) in CompanyLinks">
          <a
            :href="
              !CompanyLink.iframe
                ? CompanyLink.link
                : '/external-links/top-bar/' + getTitle(CompanyLink.title)
            "
            :key="CompanyLinkIndex"
            class="btn btn-primary header-btn ml-2 company-dynamic-button"
            v-if="CompanyLink.title && CompanyLink.link"
            :target="!CompanyLink.iframe ? '_blank' : '_self'"
            :title="CompanyLink.title"
            ><font-awesome-icon
              :icon="'fa-solid fa-' + CompanyLink.icon.name"
              v-if="CompanyLink.icon && CompanyLink.icon.name"
              class="f-12"
              style="vertical-align: middle"
            />
            {{ CompanyLink.title }}</a
          >
        </template>
      </div>
    </div>
    <div class="nav-right col-6 pull-right right-header p-0">
      <ul class="nav-menus header-extra-buttons-right">
        <!--<li class="language-nav">
          <Language />
        </li>
        <li>
          <span class="header-search"
            ><feather type="search" @click="search_open()"></feather
          ></span>
        </li>
        <Notifications />
        <li class="onhover-dropdown">
          <div class="notification-box">
            <feather type="star" @click="bookmark_open()"></feather>
          </div>
          <Bookmark v-bind:activeclass="bookmark" />
        </li>
        <Cart />
        <Message />

        <li>
          <Mode />
        </li> -->
        <li class="p-b-0 header-extra-buttons ">
          <div class="col-xl-12 p-0 left-btn">
            <b-dropdown text="Dropdown" class="add-new-btn" variant="primary">
              <template slot="button-content">
                <font-awesome-icon icon="fa-solid fa-plus-circle" /> Add New
              </template>

              <b-dropdown-item
                @click="AddVehicle()"
                class="option-btn"
                v-if="ShowVehicleAdd"
              >
                <font-awesome-icon icon="fa-solid fa-car" /> Add Vehicle
              </b-dropdown-item>

              <b-dropdown-item
                v-if="trailersModule && ShowTrailerAdd"
                @click="AddTrailer()"
                class="option-btn"
              >
                <img
                  src="@/assets/images/trailer.png"
                  class="trailer-icon-width"
                />
                Add Trailer
              </b-dropdown-item>

              <b-dropdown-item
                @click="AddDriver()"
                class="option-btn"
                v-if="ShowDriverAdd"
              >
                <font-awesome-icon icon="fa-solid fa-user-plus" /> Add Driver
              </b-dropdown-item>

              <b-dropdown-item
                :to="{ path: '/documents' }"
                class="option-btn"
                v-if="ShowDocumentAdd"
              >
                <font-awesome-icon icon="fa-solid fa-file" /> Add Document
              </b-dropdown-item>
              <b-dropdown-item
                @click="AddAsset()"
                class="option-btn"
                v-if="ShowAssetsAdd"
              >
                <font-awesome-icon icon="fa-solid fa-file" /> Add Asset
              </b-dropdown-item>
              <b-dropdown-item
                @click="AddManualTask()"
                class="option-btn"                
              >
                <font-awesome-icon icon="fa-solid fa-file" /> Add Manual Task
              </b-dropdown-item>
              <b-dropdown-item
                @click="BookRepair()"
                class="option-btn"                
              >
                <font-awesome-icon icon="fa-solid fa-file" /> Book Repair
              </b-dropdown-item>
              <b-dropdown-item
                @click="BookServiceAppointment()"
                class="option-btn"                
              >
                <font-awesome-icon icon="fa-solid fa-file" /> Book Service Appointment
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </li>

        <li class="p-b-0 header-extra-buttons">
          <div class="col-xl-12 p-0 left-btn">
            <b-dropdown text="Dropdown" class="add-new-btn2" variant="primary">
              <template slot="button-content">
                <font-awesome-icon icon="fa-question-circle" /> Support
              </template>

              <b-dropdown-item href="https://pocketbox.co.uk/faq" target="_blank" title="Frequently Asked Questions">
                <font-awesome-icon icon="fa-question" /> FAQs
              </b-dropdown-item>

              <b-dropdown-item  href="https://pocketbox.co.uk/help" target="_blank" title="Help Videos" >
                <font-awesome-icon icon="fa-video" /> Help Videos              
              </b-dropdown-item>
              
              <b-dropdown-item
                class="option-btn"
                v-b-modal.support-ticket-form
              >
              <font-awesome-icon icon="fa-ticket" /> Submit a Ticket
              </b-dropdown-item>
              
            </b-dropdown>
          </div>
        </li>

        <li class="maximize">
          <Maximize />
        </li>
        <Profile />
      </ul>
    </div>
    <b-modal
      id="change-profile-password"
      size="mg"
      title="Change Password"
      class="theme-modal"
    >
      <div class="form">
        <div style="height: 0; width: 0; padding: 0; overflow: hidden">
          <input type="text" />
          <input type="password" />
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Current Password</label>
              <input
                type="password"
                id="currentPassword"
                class="form-control"
                v-model="ChangePassword.old_password"
                :class="{
                  'is-invalid':
                    submitted && $v.ChangePassword.old_password.$error,
                }"
              />
              <div
                class="show-hide"
                id="currentPasswordBox"
                @click="showPassword('currentPassword')"
              >
                <span class="show"></span>
              </div>
              <div
                v-if="submitted && !$v.ChangePassword.old_password.required"
                class="d-block invalid-feedback"
              >
                Current Password is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>New Password</label>
              <input
                type="password"
                id="newPassword"
                class="form-control"
                v-model="ChangePassword.new_password"
                :class="{
                  'is-invalid':
                    submitted && $v.ChangePassword.new_password.$error,
                }"
              />
              <div
                class="show-hide"
                id="newPasswordBox"
                @click="showPassword('newPassword')"
              >
                <span class="show"></span>
              </div>
              <div
                v-if="submitted && !$v.ChangePassword.new_password.required"
                class="d-block invalid-feedback"
              >
                New Password is required
              </div>
              <div v-if="submitted && !$v.ChangePassword.new_password.minLength" class="d-block invalid-feedback">Password must be at least 8 characters long.</div>
              <div v-if="submitted && !$v.ChangePassword.new_password.strong" class="d-block invalid-feedback">Password must be strong (eg. include at least 1 capital letter, 1 number and 1 special character)</div>
            
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                id="cNewPassword"
                class="form-control"
                v-model="ChangePassword.confirm_new_password"
                :class="{
                  'is-invalid':
                    submitted && $v.ChangePassword.confirm_new_password.$error,
                }"
              />
              <div
                class="show-hide"
                id="cNewPasswordBox"
                @click="showPassword('cNewPassword')"
              >
                <span class="show"></span>
              </div>
              <div
                v-if="
                  submitted && !$v.ChangePassword.confirm_new_password.required
                "
                class="d-block invalid-feedback"
              >
                Confirm New Password is required
              </div>
              <div
                v-if="
                  submitted &&
                  !$v.ChangePassword.confirm_new_password.sameAsPassword
                "
                class="d-block invalid-feedback"
              >
                New Password and Confirm New Password should match
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="changePassword()">
          Save
        </b-button>
        <b-button size="sm" variant="primary" @click="ok()"> Close </b-button>
        <div class="loader-box f-right" v-if="Saving">
          <div class="loader-3"></div>
        </div>
      </template>
    </b-modal>

    <SupportTicket  
    :key="1" 
    ref="SupportTicket"
    ></SupportTicket>

  </div>
</template>


<script>
  import { mapState } from "vuex";
  import Bookmark from "../bookmark";
  import BonusUI from "./bonusUI";
  import MobileMenu from "./mobileMenu";
  import LevelMenu from "./levelMenu";
  import Language from "./language";
  import Notifications from "./notifications";
  import Mode from "./mode";
  import Cart from "./cart";
  import Message from "./message";
  import Maximize from "./maximize";
  import Profile from "./profile";
  import Logo from "./logo";
  import SearchBar from "./search";
  import Axios from "axios";
  import { required, sameAs, minLength } from "vuelidate/lib/validators";
  import $ from "jquery";
  import firebase from "firebase";
  import UserAuth from "@/auth/js/index";
  
  import SupportTicket from "@/pages/support_ticket/support_ticket";

  export default {
    name: "Search",
    components: {
      Bookmark,
      BonusUI,
      MobileMenu,
      LevelMenu,
      Language,
      Notifications,
      Mode,
      Cart,
      Message,
      Maximize,
      Profile,
      Logo,
      SearchBar,
      SupportTicket
    },
    data() {
      return {
        bookmark: false,
        trailersModule: false,
        CompanyLinks: [],
        FleetSubscription: {},
        AccountPermissions: [],
        ShowVehicleAdd: false,
        ShowTailerAdd: false,
        ShowDriverAdd: false,
        ShowDocumentAdd: false,
        ShowAssetsAdd: false,
        ChangePassword: {
          old_password: "",
          new_password: "",
          confirm_new_password: "",
        },
        submitted: false,
        Saving: false,
      };
    },

    validations: {
      ChangePassword: {
        old_password: { required },
        new_password: { required, minLength: minLength(8), // Minimum length of 8 characters
          // You can add additional validation rules for password strength
          strong: (value) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/.test(value),
        },
        confirm_new_password: {
          required,
          sameAsPassword: sameAs("new_password"),
        },
      },
    },
    mounted() {
      this.GetCompanyDetail();
      this.GetCompanySubscription();
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      this.AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );

      if (this.AccountPermissions) {
        if (
          this.AccountPermissions.Vehicle &&
          this.AccountPermissions.Vehicle.enable &&
          this.AccountPermissions.Vehicle.add
        ) {
          this.ShowVehicleAdd = true;
        }
        if (
          this.AccountPermissions.Trailers &&
          this.AccountPermissions.Trailers.enable &&
          this.AccountPermissions.Trailers.add
        ) {
          this.ShowTrailerAdd = true;
        }
        if (
          this.AccountPermissions.Driver &&
          this.AccountPermissions.Driver.enable &&
          this.AccountPermissions.Driver.add
        ) {
          this.ShowDriverAdd = true;
        }
        if (
          this.AccountPermissions.Documents &&
          this.AccountPermissions.Documents.enable &&
          this.AccountPermissions.Documents.add
        ) {
          this.ShowDocumentAdd = true;
        }
        if (
          this.AccountPermissions.Assets &&
          this.AccountPermissions.Assets.enable &&
          this.AccountPermissions.Assets.add
        ) {
          this.ShowAssetsAdd = true;
        }
        
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowVehicleAdd = true;
        this.ShowTrailerAdd = true;
        this.ShowDriverAdd = true;
        this.ShowDocumentAdd = true;
      }
    },
    computed: {
      ...mapState({
        menuItems: (state) => state.menu.searchData,
        megamenuItems: (state) => state.menu.megamenu,
        searchOpen: (state) => state.menu.searchOpen,
      }),
    },
    methods: {
      showPassword: function (id) {
        if ($("#" + id).attr("type") === "password") {
          $("#" + id).attr("type", "text");
          $("#" + id + "Box span").removeClass("show");
        } else {
          $("#" + id).attr("type", "password");
          $("#" + id + "Box span").addClass("show");
        }
      },
      changePassword() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.User.Password.Update, {
          token: localStorage.getItem("token"),
          ...this.ChangePassword,
        }).then((Response) => {
          this.Saving = false;
          if (Response.data.success) {
            this.$swal
              .fire(
                "Your Password has been Updated Successfully",
                "",
                "success"
              )
              .then(() => {
                firebase
                  .auth()
                  .signOut()
                  .then(() => {
                    UserAuth.Logout();
                    this.$router.replace("/auth/login");
                  });
                this.$router.push("/");
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      GetCompanyDetail() {
        var CompanyData = JSON.parse(localStorage.getItem("Company"));
        if (
          CompanyData.fleet_settings_key != "" &&
          CompanyData.fleet_settings_key != null
        ) {
          var CompanySettingsKey = JSON.parse(CompanyData.fleet_settings_key);
          if (typeof CompanySettingsKey.CompanyLinks != "undefined") {
            this.CompanyLinks = CompanySettingsKey.CompanyLinks;
          }
        }
      },
      GetCompanySubscription() {
        var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        const isTrailer = FleetSubscriptionModules.Trailers;
        if (isTrailer) {
          this.trailersModule = true;
        }
      },
      AddTrailer() {
        this.$router.push("/trailer-add");
      },
      AddVehicle() {
        Axios.post(Endpoints.Vehicle.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            var vehicles = Response.data.vehicles;
            if (
              this.FleetSubscription &&
              this.FleetSubscription.max_vehicle > vehicles.length
            ) {
              this.$router.push("/vehicle-add");
            } else {
              this.$swal(
                "You have reached your subscription's maximum allowed vehicles. Please contact us to add more vehicles",
                "",
                "error"
              );
            }
          }
        });
      },
      AddDriver() {
        Axios.post(Endpoints.Driver.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            var drivers = Response.data.drivers;
            if (
              this.FleetSubscription &&
              this.FleetSubscription.max_drivers > drivers.length
            ) {
              this.$router.push("/driver-add");
            } else {
              this.$swal(
                "You have reached your subscription's maximum allowed drivers. Please contact us to add more drivers",
                "",
                "error"
              );
            }
          }
        });
      },
      AddAsset() {
        Axios.post(Endpoints.Assets.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            var assets = Response.data.AssetsList;
            if (
              this.FleetSubscription &&
              this.FleetSubscription.max_asset > assets.length
            ) {
              this.$router.push("/assets/add");
            } else {
              this.$swal(
                "You have reached your subscription's maximum allowed assets. Please contact us to add more assets",
                "",
                "error"
              );
            }
          }
        });
      },
      AddManualTask() {
        this.$router.push("/task-add");
      },
      BookRepair() {
        this.$router.push("/book-repair");
      },
      BookServiceAppointment() {
        this.$router.push("/book-service-appointment");
      },      
      search_open() {
        this.$store.state.menu.searchOpen = true;
      },
      bookmark_open() {
        this.bookmark = !this.bookmark;
      },
      getTitle(title) {
        return title
          .replace(/(?!\w|\s)./g, "-")
          .replace(/\s+/g, "-")
          .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
          .toLowerCase();
      },
    },
  };
</script>
<style>
.add-new-btn2 .fa-circle-question path{
  color:#FFF !important
}
.header-extra-buttons-right .btn {
    padding: 0.375rem 12px !important;
}
</style> 